import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const ifilAbsContract = require('./MultiSig.json')

let web3 = $web3js.getWeb3();

let fundBackposalcontractAddress = $bizConfig.fPoolFundBackProposalContractAddress;

let proposalcontractAddress = $bizConfig.fPoolProposalContractAddress;
let contractAddress = $bizConfig.multiSigContractAddress;

let contractConst = {
    contract: web3 ? new web3.eth.Contract(ifilAbsContract.abi, contractAddress) : '',
}

const getMultiSignAddress = () => {
    return contractAddress;
}

const getMultiSignContract = () => {
    return contractConst.contract;
}

const getProposalTxids = ([proposalcontractAddress], options) => {
    return $web3js.call(
        getMultiSignContract().methods.getProposalTxids, [proposalcontractAddress], options
    );
};

const getMultiSigInfos = ([_txIds], options) => {
    return $web3js.call(
        getMultiSignContract().methods.getMultiSigInfos, [_txIds], options,
        getMultiSigInfosInfos
    );
};

const getMultiSigInfosInfos = async(res2) => {

    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let index = 0;
            let threshold = res[index++];
            let ownerCount = res[index++];
            let txSignCount = res[index++];
            let state = res[index++];


            let item = {
                threshold,
                ownerCount,
                txSignCount,
                state


            }
            resList.push(item);

        }
    }
    return resList;
};
const getjudgeAlreadySign = ([_user, _txIds], options) => {
    return $web3js.call(
        getMultiSignContract().methods.judgeAlreadySign, [_user, _txIds], options,
        judgeAlreadySignInfos
    );
};

const judgeAlreadySignInfos = async(res2) => {
    let resList = [];
    if (res2.length > 0) {
        for (let res of res2) {
            let issign = res

            let item = {
                issign
            }
            resList.push(item);

        }
    }
    return resList;
};

const fPoolProposalSign = ([_txId], options, callback) => {
    return $web3js.send(getMultiSignContract().methods.sign, [_txId], options, callback);
};

const fPoolProposalSignEstimateSend = async([_txId], options) => {
    let gasPromise = $web3js.estimateSend(
        getMultiSignContract().methods.sign, [_txId], options
    );
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}


const getfundBackProposalTxid = ([], options) => {
    return $web3js.call(
        getMultiSignContract().methods.getCurrentProposalTxid, [fundBackposalcontractAddress], options
    );
};


const getProposalTxid = ([], options) => {
    return $web3js.call(
        getMultiSignContract().methods.getCurrentProposalTxid, [proposalcontractAddress], options
    );
};

const fPoolProposalIssueProposal = async([_proposalAddress, name, describe, _proposalData, _extraData, tokenAddress], options, callback) => {

    _proposalData = JSON.parse(JSON.stringify(_proposalData))
    _extraData = JSON.parse(JSON.stringify(_extraData))
    _extraData.pid = $web3js.stringToBytes32(_extraData.pid);
    _proposalData.amount = await $erc20.toErc20Value(_proposalData.amount, _proposalData.tokenAddress);
    _extraData.price = await $erc20.toErc20Value(_extraData.price, tokenAddress);

    let _type = ['uint256', 'address', 'uint256', 'address', 'uint256', 'uint8'];
    let _data = [_proposalData.amount, _proposalData.recvAddress,
        _proposalData.expireTime, _proposalData.tokenAddress, _proposalData.startTime, _proposalData.fundType
    ];
    let proposalData = $web3js.encodeParameters(_type, _data)

    let _extraDatatype = ['bytes32', 'uint256', 'uint256', 'uint256'];
    let _extraDatadata = [_extraData.pid, _extraData.power,
        _extraData.price, _extraData.effectPeriod
    ];
    let extraData = $web3js.encodeParameters(_extraDatatype, _extraDatadata)
    return $web3js.send(getMultiSignContract().methods.issueProposal, [_proposalAddress, name, describe, proposalData, extraData], options, callback);
};

const fPoolProposalIssueProposalEstimateSend = async([_proposalAddress, name, describe, _proposalData, _extraData, tokenAddress], options) => {
        _proposalData = JSON.parse(JSON.stringify(_proposalData))
        _extraData = JSON.parse(JSON.stringify(_extraData))
        _extraData.pid = $web3js.stringToBytes32(_extraData.pid);
        _proposalData.amount = await $erc20.toErc20Value(_proposalData.amount, _proposalData.tokenAddress);
        _extraData.price = await $erc20.toErc20Value(_extraData.price, tokenAddress);

        let _type = ['uint256', 'address', 'uint256', 'address', 'uint256', 'uint8'];
        let _data = [_proposalData.amount, _proposalData.recvAddress,
            _proposalData.expireTime, _proposalData.tokenAddress, _proposalData.startTime, _proposalData.fundType
        ];
        let proposalData = $web3js.encodeParameters(_type, _data)

        let _extraDatatype = ['bytes32', 'uint256', 'uint256', 'uint256'];
        let _extraDatadata = [_extraData.pid, _extraData.power,
            _extraData.price, _extraData.effectPeriod
        ];
        let extraData = $web3js.encodeParameters(_extraDatatype, _extraDatadata)

        let gasPromise = $web3js.estimateSend(
            getMultiSignContract().methods.issueProposal, [_proposalAddress, name, describe, proposalData, extraData], options
        );
        let gasPricePromise = $web3js.getGasPrice();

        let [e1, gas] = await $utils.awaitWrap(gasPromise);
        let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
        if (!!e1) {
            Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
            return null;
        }

        let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
        return { gas, gasPrice, fee };
    }

export default {
    getMultiSignAddress,
    getMultiSignContract,
    getProposalTxids,
    getMultiSigInfos,
    getjudgeAlreadySign,
    fPoolProposalSign,
    fPoolProposalSignEstimateSend,
    getfundBackProposalTxid,
    getProposalTxid,
    fPoolProposalIssueProposal,
    fPoolProposalIssueProposalEstimateSend
}



// WEBPACK FOOTER //
// ./src/lib/contract/multiSig/index.js